import { Button, ButtonWithIcon } from '@oy/uidesktop';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslate } from 'src/hooks';
import { BankMaintenanceSideModal } from 'src/pages/Disbursement/components/Maintenance/BankMaintenanceSideModal/BankMaintenanceSideModal';
import { showChooseCreateModal } from '../../../redux/actions';
import styles from './BulkDisbursementCreationButton.module.css';
import { useBulkDisbursementCreationButton } from './useBulkDisbursementCreationButton';

type BulkDisbursementCreationButtonProps = {
  userHasMakerPermissionBulk: boolean;
};

function BulkDisbursementCreationButton({
  userHasMakerPermissionBulk,
}: BulkDisbursementCreationButtonProps) {
  const { getTranslation } = useTranslate();
  const dispatch = useDispatch();
  const { state, action } = useBulkDisbursementCreationButton();
  const {
    showVendorMaintenance,
    showSideModal
  } = state;

  const {
    handleToggleSideModal
  } = action;
  return (
    <div className={styles.container} id="coachBulkList4">
      {userHasMakerPermissionBulk && (
        <div
          onClick={() => {
            dispatch(showChooseCreateModal(true));
          }}
        >
          <ButtonWithIcon color={Button.Color.Primary} iconName="add">
            {getTranslation('common_createNewTransaction')}
          </ButtonWithIcon>
        </div>
      )}

      <Link to={'/settings/bulk-receipt'}>
        <ButtonWithIcon
          isDedupe
          iconName="configs"
          className={styles.button}
          color={ButtonWithIcon.Color.Secondary}
          buttonType={ButtonWithIcon.Type.Outlined}
        ></ButtonWithIcon>
      </Link>
      {
        showVendorMaintenance && 
          <ButtonWithIcon
            isDedupe
            iconName="bank"
            className={styles.button}
            color={ButtonWithIcon.Color.Secondary}
            buttonType={ButtonWithIcon.Type.Outlined}
            onClick={handleToggleSideModal}
          ></ButtonWithIcon>
      }
      {
        showSideModal && <BankMaintenanceSideModal
          source="button_bulk_disburse_list"
          show={showSideModal}
          handleToggleSideModal={handleToggleSideModal}
        />
      }
    </div>
  );
}

export default BulkDisbursementCreationButton;
